import React from 'react';

const PhrasePractice = ({
  enlargedPhrase,
  closeEnlargedView,
  isRecording,
  startRecording,
  stopRecording,
  transcription,
  accuracy,
  recordingTime,
  audioURL,
  transcriptionFeedback,
  isTranscribing,
  transcribeAudio
}) => {
  if (!enlargedPhrase) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50" onClick={closeEnlargedView}>
      <div 
        className={`relative p-8 rounded-xl shadow-2xl w-3/4 max-w-4xl text-center transform transition-all duration-300 scale-105 bg-gray-900/80 backdrop-blur-md text-white`}
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          onClick={closeEnlargedView} 
          className={`absolute top-4 right-4 text-3xl font-bold text-gray-400 hover:text-white`}
        >
          &times;
        </button>
        <p className="text-5xl font-bold mb-6 break-words">{enlargedPhrase.text}</p>
        <p className="text-3xl font-light mb-8 italic break-words">{enlargedPhrase.translation}</p>
        
        <div className="mt-6">
          <button
            onClick={isRecording ? stopRecording : startRecording}
            className={`px-8 py-4 text-2xl font-semibold rounded-full transition-transform transform hover:scale-110 shadow-lg
              ${isRecording
                ? 'bg-red-600 hover:bg-red-700 text-white animate-pulse'
                : 'bg-red-600 hover:bg-red-700 text-white'}`
            }
          >
            {isRecording ? `Đang ghi âm... ${recordingTime}` : 'Bắt đầu Luyện tập'}
          </button>

          {audioURL && !isRecording && (
            <div className="mt-4">
              <button
                onClick={transcribeAudio}
                disabled={isTranscribing}
                className={`px-6 py-3 text-xl font-semibold rounded-full transition-transform transform hover:scale-105 shadow-lg
                  ${isTranscribing
                    ? 'bg-gray-500 text-white cursor-not-allowed'
                    : 'bg-red-600 hover:bg-red-700 text-white'}`
                }
              >
                {isTranscribing ? 'Đang xử lý...' : 'Kiểm tra phát âm'}
              </button>
            </div>
          )}
        </div>

        {transcription && (
          <div className="mt-8 p-6 bg-gray-100 rounded-lg text-2xl border border-gray-200">
            <p className="text-gray-600">
              Bạn đã nói: "<span className="font-semibold italic">{transcription}</span>"
            </p>
            {accuracy !== null && (
              <p className={`mt-2 font-bold ${accuracy > 80 ? 'text-green-600' : accuracy > 50 ? 'text-yellow-600' : 'text-red-600'}`}>
                Độ chính xác: {accuracy}%
              </p>
            )}
            {transcriptionFeedback && (
              <p className="mt-2 text-lg text-gray-600">
                {transcriptionFeedback}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhrasePractice;
